import { Box, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./CohortViewHeader.css";

const CohortViewHeader = ({ onBack, showBack }) => (
  <Box className="cohort-view-header">
    {showBack && (
      <IconButton
        className="cohort-view-header-back-arrow-icon-button"
        onClick={onBack}
      >
        <ArrowBackIcon className="cohort-view-header-back-arrow-icon" />
      </IconButton>
    )}
  </Box>
);

export default CohortViewHeader;
